import React from 'react';
import './Education.css';

function Education() {
  const educationData = [
    {
      id: 1,
      institution: 'Government Engineering College Bikaner',
      degree: 'Bachelor of Technology - BTech',
      field: 'Computer Science and Engineering',
      duration: 'Jul 2023 - Jun 2027',
      period: '4 years',
      activities: 'Activities and societies: Chess',
      description: 'Pursuing BTech in Computer Science and Engineering with focus on Full Stack Development, Machine Learning, and Software Engineering.',
      current: true,
      icon: '🎓'
    },
    {
      id: 2,
      institution: 'Allen Carrier Institute Kota',
      degree: 'JEE Mains & Advance',
      field: 'Engineering Preparation',
      duration: 'May 2022 - Jun 2023',
      period: '1 year 2 months',
      description: 'Prepared for JEE Mains and Advanced examinations, building strong foundation in Physics, Chemistry, and Mathematics.',
      icon: '📐'
    },
    {
      id: 3,
      institution: 'PPS Jodhpur',
      degree: 'Senior Secondary Education',
      field: 'Class 12th',
      duration: '2021 - 2022',
      period: '1 year',
      description: 'Completed senior secondary education with focus on Science stream.',
      icon: '📚'
    },
    {
      id: 4,
      institution: 'PPS Jodhpur',
      degree: 'Secondary Education',
      field: 'Class 10th',
      duration: '2019 - 2020',
      period: '1 year',
      description: 'Completed secondary education with excellent academic performance.',
      icon: '📖'
    }
  ];

  return (
    <section id="education">
      <p className="section__text__p1 outfit-semibold">Explore My</p>
      <h1 className="title playfair-display-bold">Educational Journey</h1>
      <div className="education-container">
        <div className="education-timeline">
          {educationData.map((edu, index) => (
            <div 
              key={edu.id} 
              className={`education-item ${index % 2 === 0 ? 'left' : 'right'} ${edu.current ? 'current' : ''}`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="education-content">
                <div className="edu-icon">{edu.icon}</div>
                <div className="edu-header">
                  <h3 className="outfit-semibold">{edu.institution}</h3>
                  {edu.current && <span className="current-badge">Current</span>}
                </div>
                <div className="degree-info">
                  <h4 className="outfit-medium">{edu.degree}</h4>
                  <p className="field">{edu.field}</p>
                </div>
                <div className="edu-meta">
                  <span className="duration">📅 {edu.duration}</span>
                  <span className="period">⏱️ {edu.period}</span>
                </div>
                <p className="edu-description outfit-regular">{edu.description}</p>
                {edu.activities && (
                  <div className="activities">
                    <span className="activities-label">🎯 {edu.activities}</span>
                  </div>
                )}
              </div>
              <div className="education-dot"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Education;
